module.exports = __webpack_public_path__ + "media/images/emblems/Gerlafingen-blason-4f540adc58cfb8f94b95ad5af999f990.png";